@if(component){
<div class="flex-column m-b-10">

    <text-box class="m-b-10 m-b-8-s m-b-8-m"
              [data]="component" />

    @if(component.sectionName){
    <p class="h2 m-b-5 col-1"
       *iCms="'sectionName' of component; skipEmpty: true"></p>
    }

    @if(component.items.length){
    <div [grid]="client.sizeId > 1 ? 4 : 2"
         [gridColumnGap]="client.sizeId > 1 ? '20px' : '16px'"
         [gridRowGap]="client.sizeId > 1 ? '20px' : '16px'">
        @for(item of component.items; track $index){
        <div>
            <div class="w-12 b-a b-col-5 overflow-hidden"
                 [id]="item.anchorId || ''"
                 style="border-radius: 12px;">
                <df-image-wrapper>
                    <img [ratio]="1"
                         [dfImage]="item.image || ''">
                </df-image-wrapper>
            </div>
            <div class="flex flex-justify-between">
                <p class="h3 col-1 m-t"
                   *iCms="'title' of item; skipEmpty:true"></p>

                @if(client.sizeId > 0
                &&item.cta){
                <href [link]="item.url">
                    <span class="m-t s2"
                          inlineButton
                          *iCms="'cta' of item; skipEmpty: true">
                    </span>
                </href>
                }
            </div>

            <p class="p2 col-11 m-t-1"
               *iCms="'subtitle' of item; skipEmpty:true"></p>

            @if(client.sizeId < 1
              &&item.cta){
              <href
              [link]="item.url">
                <span class="m-t-2"
                      [buttonStyle]="'text-button'">
                    <span class="s1"
                          *iCms="'cta' of item; skipEmpty: true">
                    </span>
                </span>
                </href>
                }
        </div>
        }
    </div>
    }
</div>
}